module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', [_vm._c('PageHeader', {
    attrs: {
      "title": 'Share ' + (_vm.chapter ? _vm.chapter.title : 'Chapter')
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "main-content container-fluid xs-pt-0"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12"
  }, [_vm._c('Panel', {
    staticClass: "panel panel-default panel-border-color panel-border-color-primary xs-mt-0"
  }, [(_vm.chapter) ? _vm._c('PanelBody', {
    staticClass: "xs-pt-20 xs-pb-20"
  }, [_vm._c('div', {
    staticClass: "xs-mb-20 text-bold"
  }, [_vm._v("Enter the email address of the users you would like to share with.")]), _vm._v(" "), _vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3"
  }, [_vm._c('label', {
    staticClass: "sm-pt-10",
    attrs: {
      "for": "txtEmail"
    }
  }, [_vm._v("Search on email address")])]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-9"
  }, [_vm._c('div', {
    staticClass: "input-group"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchEmail),
      expression: "searchEmail"
    }],
    staticClass: "form-control pull-left",
    attrs: {
      "type": "email",
      "id": "txtEmail",
      "placeholder": "enter email address"
    },
    domProps: {
      "value": _vm._s(_vm.searchEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "input-group-addon"
  }, [_vm._c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "disabled": !_vm.emailValid || _vm.searching
    },
    on: {
      "click": function($event) {
        _vm.searchUser()
      }
    }
  }, [_vm._v("Search")])])]), _vm._v(" "), (_vm.userSearchResults.length > 0) ? _vm._c('div', {
    staticClass: "search-results"
  }, [_vm._c('table', _vm._l((_vm.userSearchResults), function(user) {
    return _vm._c('tr', [_vm._c('td', {
      staticClass: "email"
    }, [_vm._v(_vm._s(user.email))]), _vm._v(" "), _vm._c('td', {
      staticStyle: {
        "width": "50px"
      }
    }, [_vm._c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          _vm.addEmail(user)
        }
      }
    }, [_vm._c('i', {
      staticClass: "fas fa-plus"
    })])])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.showNoResultsMessage) ? _vm._c('div', {
    staticClass: "search-results no-results"
  }, [_vm._v("\n                  No users found with this email address.\n                ")]) : _vm._e()])]), _vm._v(" "), (_vm.sharingEmails.length > 0) ? _vm._c('div', [_vm._c('hr'), _vm._v(" "), _vm._c('strong', [_vm._v("Sharing '" + _vm._s(_vm.chapter.title) + "' with:")]), _vm._v(" "), _vm._c('div', {
    staticClass: "row sharing-emails"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_vm._c('table', _vm._l((_vm.sharingEmails), function(user) {
    return _vm._c('tr', [_vm._c('td', [_vm._v(_vm._s(user.email))]), _vm._v(" "), _vm._c('td', [_vm._c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          _vm.removeEmail(user)
        }
      }
    }, [_vm._c('i', {
      staticClass: "fas fa-times"
    })])])])
  }))]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_vm._c('button', {
    staticClass: "pull-right btn btn-primary btn-xl",
    attrs: {
      "disabled": _vm.sharingEmails.length <= 0
    },
    on: {
      "click": function($event) {
        _vm.share()
      }
    }
  }, [_vm._v("Share with " + _vm._s(_vm.sharingEmails.length) + " user" + _vm._s(_vm.sharingEmails.length > 1 ? 's' : ''))])])])]) : _vm._e()]) : _vm._c('PanelBody', {
    staticClass: "xs-pt-20 xs-pb-20"
  }, [_vm._c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("No chapter selected")])])], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23e74d86!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-sharer/ChapterSharer.vue
// module id = 636
// module chunks = 1